const getDefaultDevicesState = () => {
  return {
    allDevices: [],
  }
}

export default getDefaultDevicesState()
export { getDefaultDevicesState }
